const html = require('choo/html')

module.exports = function LoadingMessage(state, emit) {
  return html`
    <div id="app">
      <div id="loading">
        <ul class="buttons row space-tight align-center">
          <li class="square size-biggest"><div class="fake-button"></div></li>
          <li class="square size-biggest"><div class="fake-button"></div></li>
          <li class="square size-biggest"><div class="fake-button"></div></li>
          <li class="square size-biggest"><div class="fake-button"></div></li>
          <li class="square size-biggest"><div class="fake-button"></div></li>
          <li class="square size-biggest"><div class="fake-button"></div></li>
          <li class="square size-biggest"><div class="fake-button"></div></li>
          <li class="square size-biggest"><div class="fake-button"></div></li>
          <li class="square size-biggest"><div class="fake-button"></div></li>
        </ul>
      </div>
    </div>
  `
}
